import {
  pxToRem,
  fontDpr
} from '../../../../../public-resource/libs/cssCompute'
const str = `
<style>
  .tips {
    background: linear-gradient(53deg, #bcc2cf 0%, #ced3de 100%);
    color: #fff;
    width: ${pxToRem(54)};
    height: ${pxToRem(30)};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${pxToRem(18)};
    border-radius: ${pxToRem(4)};
  }
  .nav-desc {
    height: ${pxToRem(74)};
    font-size: ${pxToRem(26)};
    margin-top: ${pxToRem(13)};
    margin-bottom: ${pxToRem(10)};
    color: #666666;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .info {
    color: #999999;
    font-size: ${fontDpr(12)};
    line-height: 1;
  }
</style>
`
export default str



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/clock/wxStyle.js